import React from 'react';

const Speaking = ({ iconColor, width, height }) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 48 48'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24.8577 10H23.1398C21.8275 10 20.6359 10.5686 19.7721 11.4848C18.9084 12.4011 18.3724 13.6662 18.3724 15.0573V24.0395C18.3724 25.4316 18.9084 26.6956 19.7721 27.6119C20.6359 28.5282 21.8275 29.0967 23.1398 29.0967H24.8577C26.17 29.0967 27.3616 28.5282 28.2254 27.6119C29.0892 26.6957 29.6251 25.4305 29.6251 24.0395V15.0573C29.6251 13.6652 29.0891 12.4011 28.2254 11.4848C27.3617 10.5685 26.1701 10 24.8577 10ZM19.0312 37.1798C19.0312 37.6328 19.3785 38 19.8044 38H28.1943C28.6213 38 28.9675 37.6317 28.9675 37.1798C28.9675 36.7268 28.6202 36.3596 28.1943 36.3596H19.8044C19.3774 36.3596 19.0312 36.7279 19.0312 37.1798ZM16.7732 23.2901C16.3462 23.2901 16 23.6584 16 24.1103L16.0012 24.1102C16.0012 26.1223 16.7787 27.9538 18.0328 29.2865C19.287 30.6147 21.0134 31.4383 22.9092 31.4383H23.2273V34.0648H21.118C20.691 34.0648 20.3448 34.4331 20.3448 34.885C20.3448 35.338 20.6921 35.7052 21.118 35.7052H26.8831C27.3101 35.7052 27.6563 35.3368 27.6563 34.885C27.6563 34.432 27.309 34.0648 26.8831 34.0648H24.7738V31.4383H25.0919C26.9887 31.4383 28.7153 30.6135 29.9716 29.2831C31.2236 27.9527 32 26.1213 32 24.1103C32 23.6573 31.6538 23.2901 31.2279 23.2901C30.8008 23.2901 30.4547 23.6584 30.4547 24.1103C30.4547 25.6764 29.8519 27.0983 28.8803 28.129C27.9085 29.1597 26.5681 29.7991 25.0918 29.7991H22.9092C21.4339 29.7991 20.0924 29.1597 19.1208 28.129C18.1492 27.0982 17.5464 25.6763 17.5464 24.1103C17.5464 23.6573 17.1992 23.2901 16.7732 23.2901Z'
            fill={iconColor}
        />
    </svg>
);

Speaking.defaultProps = {
    iconColor: "#1A1A1A",
    width: "48",
    height: "48",
};

export default Speaking;
